import React from 'react'
import AddBoxIcon from '@mui/icons-material/AddBox'
import AddCommentIcon from '@mui/icons-material/AddComment'
import AddIcon from '@mui/icons-material/Add'
import AppendDataSource from './AppendDataSource'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import Box from '@mui/material/Box'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CreateCube from './CreateCube'
import CreateDataSourceFromExisting from './CreateDataSourceFromExisting'
import CreateDataSourceFromWizardRawFiles from './CreateDataSourceFromWizardRawFiles'
import CreateNewDataSource from './CreateNewDataSource'
import DataTransformation from './DataTransformation'
import DeleteCube from './DeleteCube'
import DeleteDataSource from './DeleteDataSource'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline'
import DuplicateDataSource from './DuplicateDataSource'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import ImportMasking from './ImportMasking'
import ImportSegmentation from './ImportSegmentation'
import InventoryIcon from '@mui/icons-material/Inventory'
import ItemMaskingChange from './ItemMaskingChange'
import MasksIcon from '@mui/icons-material/Masks'
import MeasureDefinition from './MeasureDefinition'
import MemoryIcon from '@mui/icons-material/Memory'
import LibraryAddIcon from '@mui/icons-material/LibraryAdd'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ProcessUpdateCube from './ProcessUpdateCube'
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder'
import RecyclingIcon from '@mui/icons-material/Recycling'
import RemoveMembers from './RemoveMembers'
import RenameDataSource from './RenameDataSource'
import RunCustomSqlStatement from './RunCustomSqlStatement'
import SegmentIcon from '@mui/icons-material/Segment'
import SegmentationAssignment from './SegmentationAssignment'
import SegmentationBuilder from './SegmentationBuilder'
import SsisJob from './SsisJob'
import StraightenIcon from '@mui/icons-material/Straighten';
import TransformIcon from '@mui/icons-material/Transform'
import TruncateDataSource from './TruncateDataSource'
import UpdateCube from './UpdateCube'
import UpdateIcon from '@mui/icons-material/Update'
import UploadNewDatabase from './UploadNewDatabase'

export const EMPTY_OBJECT = {
    "databaseId": -1,
    "dataSourceSystemName": "",
    "dataSourceName": "",
    "databaseName": "",
    "membersToRemove": [],
    "removeFromSegmentation": false,
    "removeFromMasking": false,
    "removeFromFacts": false,
    "selectedDimensionSystemName": "",
    "selectedZipFileId": "",
    "selectedZipFile": "",
    "selectedFileWithinZip": "",
    "selectedSourceColumn": "",
    "selectedTargetColumn": "",
    "rawSql": "",
    "ssisJobId": -1,
    "wizardFile": "",
    "wizardTextQualifier": -1,
    "sourceFiles": [],
    "originDatabaseId": -1,
    "originDatabaseDataSourceSystemName": "",
    "originDatabaseDataSourceName": "",
    "appendDimensionInfo": [],
    "doNotImportFacts": false,
    "getFactsAllMembers": true,
    "getFactsForSpecificMembers": false,
    "transformSelections": [],
    "delimiter": 0,
    "customDelimiter": "",
    "excelDataTable": "",
    "excelDataTables": [],
    "importFromExistingMembers": false,
    "segmentationDeclaration": [],
    "segmentationAssignments": [],
    "memberMaskings": [],
    "measureChanges": []
}

export const ALL_ACTIONS = [
    { 
        name: "ADD",
        icon: <AddIcon />,
        text: "Create New Data Source",
        key: 3,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && (data.dataSourceName && data.dataSourceName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<CreateNewDataSource 
                key={key}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                onSave={onSave} />)
        }
    },
    {
        name: "RENAME",
        icon: <DriveFileRenameOutlineIcon />,
        text: "Rename Data Source",
        key: 2,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) && (data.dataSourceName && data.dataSourceName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<RenameDataSource 
                key={key}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                onSave={onSave} />)
        }
    },
    {
        name: "DELETE",
        icon: <DeleteForeverIcon />,
        text: "Delete Data Source",
        key: 4,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && 
                (data.dataSourceName && data.dataSourceName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<DeleteDataSource 
                key={key}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                onSave={onSave} />)
        }
    },
    {
        name: "TRUNCATE",
        icon: <RecyclingIcon />,
        text: "Truncate Data Source",
        key: 5,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<TruncateDataSource 
                key={key}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                onSave={onSave} />)
        }
    },
    {
        name: "DUPLICATE",
        icon: <ContentCopyIcon />,
        text: "Duplicate Data Source",
        key: 6,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) && (data.dataSourceName && data.dataSourceName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<DuplicateDataSource 
                key={key}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                onSave={onSave} />)
        }
    },
    {
        name: "REMOVEMEMBERS",
        icon: <DeleteSweepIcon />,
        text: "Remove Members From Dimension",
        key: 7,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<RemoveMembers 
                key={key}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                onSave={onSave} />)
        }
    },
    {
        name: "IMPORTMASKING",
        icon: <MasksIcon />,
        text: "Import Masking",
        key: 8,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) &&
                (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) &&
                (data.selectedDimensionSystemName && data.selectedDimensionSystemName.trim().length > 0) &&
                (data.selectedFileWithinZip && data.selectedFileWithinZip.trim().length > 0) &&
                (data.selectedSourceColumn && data.selectedSourceColumn.trim().length > 0) &&
                (data.selectedTargetColumn && data.selectedTargetColumn.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<ImportMasking 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                onSave={onSave} />)
        }
    },
    {
        name: "IMPORTSEGMENTATION",
        icon: <SegmentIcon />,
        text: "Import Segmentation",
        key: 9,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) &&
                (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) &&
                (data.selectedDimensionSystemName && data.selectedDimensionSystemName.trim().length > 0) &&
                (data.selectedFileWithinZip && data.selectedFileWithinZip.trim().length > 0) &&
                (data.selectedSourceColumn && data.selectedSourceColumn.trim().length > 0) &&
                (data.selectedTargetColumn && data.selectedTargetColumn.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<ImportSegmentation 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                onSave={onSave} />)
        }
    },
    {
        name: "RAWSQL",
        icon: <QueryBuilderIcon />,
        text: "Raw SQL Statement",
        key: 10,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            // rawSql
            if ((data.databaseId !== -1) &&
                (data.rawSql && data.rawSql.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<RunCustomSqlStatement 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                onSave={onSave} />)
        }
    },
    {
        name: "NEWDATABASE",
        icon: <LibraryAddIcon />,
        text: "Load New Database From File",
        key: 11,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && 
                (data.databaseName && data.databaseName.trim().length > 0) && 
                (data.selectedFileWithinZip && data.selectedFileWithinZip.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<UploadNewDatabase 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                onSave={onSave} />)
        }
    },
    {
        name: "RUNSSISJOB",
        icon: <InventoryIcon />,
        text: "Run SSIS Package",
        key: 12,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && 
                (data.ssisJobId !== -1)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getMeasureAggregations, onSave) => {
            return (<SsisJob 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                onSave={onSave} />)
        }
    },
    {
        name: "NEWDATASOURCEFROMRAWWIZARDFILES",
        icon: <AttachFileIcon />,
        text: "Import Data Source From Raw Files",
        key: 13,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) &&
                (data.dataSourceName && data.dataSourceName.trim().length > 0) &&
                (data.wizardFile && data.wizardFile.trim().length > 0) &&
                (data.sourceFiles && data.sourceFiles.length > 0)) {
                    if ((data.excelDataTables && data.excelDataTables.length > 0) || ((data.wizardTextQualifier && data.wizardTextQualifier > -1) || (data.wizardTextQualifier === 0))) {
                        return true
                    } else {
                        return false
                    }
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<CreateDataSourceFromWizardRawFiles 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                readTablesFromExcel={readTablesFromExcel}
                readTablesFromExcelFiles={readTablesFromExcelFiles}
                onSave={onSave} />)
        }
    },
    {
        name: "NEWDATASOURCEFROMEXISTINGSOURCE",
        icon: <ImportExportIcon />,
        text: "Create Data Source From Existing",
        key: 15,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) &&
                (data.dataSourceName && data.dataSourceName.trim().length > 0) &&
                (data.originDatabaseId && data.originDatabaseId !== -1) &&
                (data.originDatabaseDataSourceSystemName && data.originDatabaseDataSourceSystemName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<CreateDataSourceFromExisting 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "APPENDDATASOURCE",
        icon: <AddCommentIcon />,
        text: "Append Data Source",
        key: 14,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) &&
                (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) &&
                (data.originDatabaseId && data.originDatabaseId !== -1) &&
                (data.originDatabaseDataSourceSystemName && data.originDatabaseDataSourceSystemName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<AppendDataSource 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "TRANSFORM",
        icon: <TransformIcon />,
        text: "Transform",
        key: 16,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && 
                (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) &&
                (data.originDatabaseId !== -1)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<DataTransformation 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                getTransformData={getTransformData}
                onSave={onSave} />)
        }
    },
    {
        name: "CREATECUBE",
        icon: <AddBoxIcon />,
        text: "Create Cube",
        key: 17,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId !== -1) && 
                (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0) &&
                (data.originDatabaseId && data.originDatabaseId !== -1)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<CreateCube 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "PROCESSCUBE",
        icon: <MemoryIcon />,
        text: "Process Cube",
        key: 18,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId && data.databaseId !== -1) &&
                (data.dataSourceName && data.dataSourceName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<ProcessUpdateCube 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "UPDATECUBE",
        icon: <UpdateIcon />,
        text: "Update Cube",
        key: 19,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId && data.databaseId !== -1) &&
                (data.dataSourceName && data.dataSourceName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<UpdateCube 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "DELETECUBE",
        icon: <HighlightOffIcon />,
        text: "Delete Cube",
        key: 20,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            if ((data.databaseId && data.databaseId !== -1) &&
                (data.databaseName && data.databaseName.trim().length > 0) &&
                (data.dataSourceSystemName && data.dataSourceSystemName.trim().length > 0)) {
                return true
            } else {
                return false
            }
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<DeleteCube 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "ADDSEGMENTS",
        icon: <SegmentIcon />,
        text: "Add Segments",
        key: 21,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            return true
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<SegmentationBuilder 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "SEGMENTATIONASSIGNMENT",
        icon: <SegmentIcon />,
        text: "Segmentation Assignment",
        key: 22,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            return true
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<SegmentationAssignment 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "ITEMMASKINGCHANGE",
        icon: <MasksIcon />,
        text: "Change Item Masking",
        key: 23,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            let validate = {}
            for (let maskItr = 0; maskItr < data["memberMaskings"].length; maskItr++) {
                let dimensionSystemName = data.memberMaskings[maskItr]["dimensionSystemName"]

                if (!validate[dimensionSystemName]) {
                    validate[dimensionSystemName] = {}
                }

                if (validate[dimensionSystemName][data.memberMaskings[maskItr]["maskingValue"].toLowerCase()]) {
                    return false
                } else {
                    validate[dimensionSystemName][data.memberMaskings[maskItr]["maskingValue"].toLowerCase()] = 1
                }
            }
            return true
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<ItemMaskingChange 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                onSave={onSave} />)
        }
    },
    {
        name: "MEASUREDEFINITION",
        icon: <StraightenIcon />,
        text: "Measure Definitions",
        key: 24,
        emptyDataItem: JSON.parse(JSON.stringify(EMPTY_OBJECT)),
        validateControl: (data) => {
            let existingMeasures = {}
            for (let measureItr = 0; measureItr < data["measureChanges"].length; measureItr++) {
                if (existingMeasures[data["measureChanges"][measureItr]["aliasName"].toLowerCase()]) {
                    return false
                } else {
                    existingMeasures[data["measureChanges"][measureItr]["aliasName"].toLowerCase()] = 1
                }
            }
            return true
        },
        renderMainComponent: (key, jobFiles, taskData, databases, ssisPackages, getDataSources, getDimensions, getDimensionMembers, readColumnsFromZipEntry, dataToolsGetDimensionsComparison, readTablesFromExcel, readTablesFromExcelFiles, getTransformData, getMeasureAggregations, onSave) => {
            return (<MeasureDefinition 
                key={key}
                jobFiles={jobFiles}
                taskData={taskData}
                databases={databases}
                ssisPackages={ssisPackages}
                getDataSources={getDataSources}
                getDimensions={getDimensions}
                getDimensionMembers={getDimensionMembers}
                readColumnsFromZipEntry={readColumnsFromZipEntry}
                dataToolsGetDimensionsComparison={dataToolsGetDimensionsComparison}
                getMeasureAggregations={getMeasureAggregations}
                onSave={onSave} />)
        }
    }
]

function AddTaskList(props) {
    // This is the render logic, no need to declare another method is a functional component
    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <h3>Add Job Step</h3>
            <List>
                {
                    ALL_ACTIONS.map((action, index) => {
                        return (<ListItem key={`all-actions-${index}`} disablePadding>
                            <ListItemButton key={`action-${index}`} onClick={() => {
                                if (props.onSelect) {
                                    props.onSelect(action)
                                }
                            }}>
                                <ListItemIcon>
                                    {action.icon}
                                </ListItemIcon>
                                <ListItemText primary={action.text} />
                            </ListItemButton>
                        </ListItem>)
                    })
                }
            </List>
        </Box>
    )
}

export default AddTaskList